import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";

class InfoModal extends Component {
  static propTypes = {
    content: PropTypes.node,
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    contentClass: PropTypes.string,
    type: PropTypes.string,
    colorScheme: PropTypes.string
  };

  render() {
    const {
      content,
      isVisible,
      onClose,
      title,
      contentClass,
      colorScheme,
      type
    } = this.props;
    return isVisible ? (
      <div style={{ zIndex: "9999" }}>
        <div className="modal-overlay" />
        <div className="modalVapor">
          <div className="modalVaporTitle">
            <div style={{ flex: "1 0 auto" }}>{title}</div>
            <div className="close-button" onClick={onClose}>
              <FontAwesomeIcon
                icon={["far", "times"]}
                style={{
                  color: "#0090d1",
                  fontSize: "24px",
                  cursor: "pointer"
                }}
              />
            </div>
          </div>
          <div className={contentClass ? contentClass : "modal-content"}>
            {content}
          </div>
          <div className="modal-footer">
            <Button
              kind={type ? type : "secondary"}
              onClick={onClose}
              colorScheme={colorScheme ? colorScheme : "ghost"}
            >
              <FormattedMessage id="actions.close" />
            </Button>
          </div>
        </div>
      </div>
    ) : null;
  }
}
export default InfoModal;
